import React, { useState } from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import { createStyles, makeStyles } from "@mui/styles";

import { useSelector } from "react-redux";
import CommonLayout from "../Common/Layout";
import JobsFilter from "./JobsFilter";
import Last20Jobs from "./Last20Jobs";

const Dashboard = ({ isSupplierDashboard }) => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({});
  const useStyles = makeStyles((theme) =>
    createStyles({
      StatusDrp: {
        "& .MuiSelect-select:focus": {
          backgroundColor: "transparent",
        },
      },
    })
  );
  const classes = useStyles();

  const { user } = useSelector((state) => state);
  const role = user.currentUser?.Role_id;
  const UserName = `${user.currentUser.FirstName}`;

  const handleFilterChange = (filters) => {
    setFilters((prevFilters) => ({ ...prevFilters, ...filters }));
  };

  const handleReset = () => {
    // Resetting filters to null will cause Last20Jobs to use its default load
    setFilters({});
  };

  const breadcrumbArr = [{ link: "#", displayName: "Dashboard", active: true }];

  return (
    <CommonLayout title="Dashboard" breadcrumbArr={breadcrumbArr} loading={false} autoScroll={true}>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4, ml: 0 }} className="main-contant-wrap">
        {/* For Roles other than Supplier (Supplier Role_id - 4) */}
        <AppBar
          sx={{
            position: "relative",
            boxShadow: 0,
            backgroundColor: "#e8edf1",
          }}
        >
          <Toolbar
            sx={{
              pl: { sm: 2 },
              pr: { xs: 1, sm: 1 },
              justifyContent: "space-between",
            }}
          >
            <JobsFilter
              onFilterChange={handleFilterChange}
              onSearch={handleFilterChange}
              onReset={handleReset}
              classes={classes}
              initialFilters={filters}
              excludeStatus={["completed"]}
              isSupplierDashboard={isSupplierDashboard}
            />
            {(role === 1 || (role === 2 && isSupplierDashboard === 1)) && (
              <Box sx={{ ml: 2 }}>
                <Button
                  className="btn btn-primary"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => navigate(role === 3 ? "/jobs/add" : "/admin/jobs/add", { state: { isSupplierDashboard: !!isSupplierDashboard } })}
                  style={{ whiteSpace: "nowrap" }}
                >
                  Start New Job
                </Button>
              </Box>
            )}
          </Toolbar>
        </AppBar>

        {role === 3 && (
          <Typography style={{ fontSize: "22px", fontWeight: "400", marginBottom: 5, marginTop: 30 }}>
            All Jobs
          </Typography>
        )}
        <Last20Jobs
          user={user.currentUser}
          isSupplierDashboard={isSupplierDashboard}
          filters={filters}
        />
      </Container>
    </CommonLayout>
  );
};

export default Dashboard;
